export enum AvatarQuality {
  Low = "low",
  Medium = "medium",
  High = "high",
}

export enum AvatarType {
  Heygen = "Heygen",
  Azure = "Azure",
  Audio = "Audio",
}

export interface AvatarConfig {
  readonly type: AvatarType;
}

export interface AvatarTokenConfig extends AvatarConfig {
  accessToken: string;
  region?: string;
}

export interface HeygenAvatarConfig extends AvatarConfig {
  readonly type: AvatarType.Heygen;
  avatarConfig: {
    avatarId: string;
    voiceId: string;
  };
  quality: AvatarQuality;
  accessToken: string;
}

export interface AzureAvatarConfig extends AvatarConfig {
  readonly type: AvatarType.Azure;
  region: string;
  avatarConfig: {
    character: string;
    voiceName: string;
    style: string;
    language?: string;
  };
  accessToken: string;
  iceServers: {
    urls: string[];
    username: string;
    password: string;
  };
}

export interface AudioAvatarConfig extends AvatarConfig {
  readonly type: AvatarType.Audio;
}
